import { Play } from "lucide-react";
import books from "../../../assets/image/Home/books.png";
import "./InfoBanner.css";

export default function SearchInput() {
    return (
        <div className="informativo">
            <img
                src={books}
                alt="Ícone de livros"
                className="overlay-image-right"
            />
            <h1 className="informativo-title">Acompanhe suas aulas professor(a)!</h1>
            <p className="informativo-message">
                Não se esqueça, você <br /> <span className="sublinhado-informativo">transforma</span> o futuro dos alunos!
            </p>
            <button className="informativo-button">
                Vamos lá
                <span className="button-arrow"><Play className="icon" /></span>
            </button>
        </div>
    );
}